/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowCoreModulesPlanningDtosScheduleRulesCreateTaskScheduleRuleRequest,
  FacilityFlowCoreModulesPlanningDtosScheduleRulesTaskScheduleRuleDto,
  FacilityFlowCoreModulesPlanningDtosScheduleRulesUpdateTaskScheduleRuleRequest
} from '.././models';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getTaskScheduleRules = () => {
/**
 * @summary Liste aller Schedule-Regeln für einen Task (für Regel-Builder im FE).
 */
const getApiV1TasksTaskIdScheduleRules = (
    taskId: string,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosScheduleRulesTaskScheduleRuleDto[]>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosScheduleRulesTaskScheduleRuleDto[]>(
      {url: `/api/v1/tasks/${taskId}/schedule-rules`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Neue Schedule-Regel für einen Task anlegen (Task wird wiederholbar/fällig).
 */
const postApiV1TasksTaskIdScheduleRules = (
    taskId: string,
    facilityFlowCoreModulesPlanningDtosScheduleRulesCreateTaskScheduleRuleRequest: FacilityFlowCoreModulesPlanningDtosScheduleRulesCreateTaskScheduleRuleRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosScheduleRulesTaskScheduleRuleDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosScheduleRulesTaskScheduleRuleDto>(
      {url: `/api/v1/tasks/${taskId}/schedule-rules`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesPlanningDtosScheduleRulesCreateTaskScheduleRuleRequest
    },
      options);
    }
  /**
 * @summary Bestehende Schedule-Regel bearbeiten.
 */
const putApiV1TasksTaskIdScheduleRulesRuleId = (
    taskId: string,
    ruleId: string,
    facilityFlowCoreModulesPlanningDtosScheduleRulesUpdateTaskScheduleRuleRequest: FacilityFlowCoreModulesPlanningDtosScheduleRulesUpdateTaskScheduleRuleRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosScheduleRulesTaskScheduleRuleDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosScheduleRulesTaskScheduleRuleDto>(
      {url: `/api/v1/tasks/${taskId}/schedule-rules/${ruleId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesPlanningDtosScheduleRulesUpdateTaskScheduleRuleRequest
    },
      options);
    }
  /**
 * @summary Schedule-Regel löschen.
 */
const deleteApiV1TasksTaskIdScheduleRulesRuleId = (
    taskId: string,
    ruleId: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/tasks/${taskId}/schedule-rules/${ruleId}`, method: 'DELETE'
    },
      options);
    }
  return {getApiV1TasksTaskIdScheduleRules,postApiV1TasksTaskIdScheduleRules,putApiV1TasksTaskIdScheduleRulesRuleId,deleteApiV1TasksTaskIdScheduleRulesRuleId}};
export type GetApiV1TasksTaskIdScheduleRulesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTaskScheduleRules>['getApiV1TasksTaskIdScheduleRules']>>>
export type PostApiV1TasksTaskIdScheduleRulesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTaskScheduleRules>['postApiV1TasksTaskIdScheduleRules']>>>
export type PutApiV1TasksTaskIdScheduleRulesRuleIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTaskScheduleRules>['putApiV1TasksTaskIdScheduleRulesRuleId']>>>
export type DeleteApiV1TasksTaskIdScheduleRulesRuleIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTaskScheduleRules>['deleteApiV1TasksTaskIdScheduleRulesRuleId']>>>
